const initHeroScreenSlider = () => {
	const section = document.querySelector("section.hero-screen-new");
	if (!section) {
		return;
	}

	const slider = section.querySelector(".hero-screen-new");

	const swiper = new Swiper(".hero-screen-new", {
		loop: true,
		effect: "fade",
		init: false,
		autoplay: {
			delay: 2900,
		},
		pagination: {
			el: ".hero-screen-new .swiper-pagination",
			clickable: true,
		},
	});

	swiper.on("init slideChange", function () {
		setTimeout(function () {
			document
				.querySelectorAll(".hero-screen-new .swiper-pagination-bullet")
				.forEach((el) => el.classList.remove("transition"));
			document
				.querySelector(".hero-screen-new .swiper-pagination-bullet-active")
				.classList.add("transition");
		}, 0);
	});

    swiper.init()
};

export { initHeroScreenSlider };
